__turbopack_context__.v({
  "button_transition__primary": "styles-module__zY66oa__button_transition__primary",
  "button_transition__primary_outline": "styles-module__zY66oa__button_transition__primary_outline",
  "button_transition__white": "styles-module__zY66oa__button_transition__white",
});
